import { renderTrboLastSeenSlider } from './TrboLastSeenRenderer';

const init = () => {
    const container = document.querySelector<HTMLElement>('.trboLastSeen[data-trbo-lastseen-slot]');
    if (!container) {
        return;
    }
    const slot = container.dataset.trboLastseenSlot;
    if (!slot) {
        return;
    }
    renderTrboLastSeenSlider(slot).catch(err => {
        console.error('[TrboLastSeenBootstrap] renderTrboLastSeenSlider failed', err);
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
    init();
}
